var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-block-counters"},[_c('img',{attrs:{"src":require("@/assets/icons/icon-heart-outline.png")}}),_c('h2',[_vm._v(_vm._s(_vm.$t("Many thanks for your support!")))]),_c('div',{staticClass:"cms-block-counters__columns"},[_c('RunnerCounter'),_c('SponsorCounter'),_c('CountdownTimer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }